import {gql} from '@apollo/client'

export const GET_PAYMENTS_PENDING = gql`
  query GetPaymentsPending(
    $q: String
    $fromDate: String
    $toDate: String
    $page: Int
    $sortBy: String
    $sortDirection: String
  ) {
    paymentsPending(
      q: $q
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      collection {
        id
        name
        createdAt
        payments {
          id
          date
          amount
          state
          description
          importCode
          importDetails
          importParticulars
          importReference
          xeroLink
          isDuplicate
          account {
            id
            displayName @client
            contactFullName @client
            name
            contactFirstName
            contactLastName
            customerNumber
          }
        }
        organisation {
          id
          internalName
          internalColor
        }
      }
      metadata {
        totalCount
        limitValue
      }
    }
  }
`
